class BrowserStorageUtil {
    setItem(key: string, value: unknown) {
        if (value) {
            const storedValue = typeof value === 'string' ? value : JSON.stringify(value);
            window.localStorage.setItem(key, storedValue);
        }
    }

    getItem(key: string) {
        const value = window.localStorage.getItem(key);
        if (value) {
            try {
                return JSON.parse(value);
            } catch {
                return value;
            }
        }
    }

    clearItems() {
        window.localStorage.clear();
    }
}

export default new BrowserStorageUtil();
